import React, { useEffect, useState } from "react";
import { Spin, Table, Select } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import SidebarNav from "../sidebar";
import { Link } from "react-router-dom";
import backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import {
  getWithdrawalReq,
  getWithdrawalStatus,
  sendDepositApprovalOtpApi,
  resendDepositApprovalOtpApi,
  createAdminDepositApi,
  updateDepositDetailsApi,
  markDepositActionRequiredApi,
  getUser,
} from "../../../service/api";
import { Spinner } from "react-bootstrap";
import CustomPagination from "../Pagination/pagination";
import FilterPanel from "../commoncomponent/FilterPanel";
import TableToolbar from "../commoncomponent/TableToolbar";
import { useTableSettings } from "../../../hooks/useTableSettings";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { sanitizeInput } from "../../../config/validation";
import moment from "moment";
import { toast } from "react-toastify";
import { triggerDownload } from "../../../config/downloadUtils";

const styleDelete = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  background: "white",
  borderRadius: "10px",
  boxShadow: 24,
  padding: 15,
  outline: "none",
  maxHeight: "90vh",
  overflowY: "auto",
};

const UTR_PATTERN = /^[A-Za-z0-9]{6,22}$/;
const MAX_ACTION_REQUIRED_ATTEMPTS = 5;

const tabs = ["Pending", "Action Required", "Approved", "Rejected"];

// Maps a UI tab label to the backend `status` query value.
const TAB_STATUS = {
  Pending:           "PENDING",
  "Action Required": "ACTION_REQUIRED",
  Approved:          "ACCEPT",
  Rejected:          "REJECT",
};

const formatDateTime = (val) =>
  val ? moment(val).format("DD/MM/YYYY HH:mm") : "-";

const STATUS_BADGE = {
  PENDING:          { bg: "#fff4e5", color: "#fd7e14", label: "Pending" },
  ACTION_REQUIRED:  { bg: "#fff4e5", color: "#d16c00", label: "Action Required" },
  ACCEPT:           { bg: "#eaf7ee", color: "#28a745", label: "Approved" },
  REJECT:           { bg: "#fdf0f1", color: "#dc3545", label: "Rejected" },
};
const renderStatus = (status) => {
  const s = STATUS_BADGE[status] || { bg: "#f1f5f9", color: "#6b7280", label: status || "-" };
  return <span style={{ background: s.bg, color: s.color, borderRadius: 20, padding: "3px 10px", fontWeight: 600, fontSize: 12, whiteSpace: "nowrap" }}>{s.label}</span>;
};

const ALL_COLUMNS = [
  {
    key: "user",
    title: "User",
    defaultVisible: true,
    render: (r) => {
      const content = (
        <>
          <div style={{ fontWeight: 600, color: "#1a1a2e" }}>{r?.user?.firstName} {r?.user?.lastName}</div>
          <div style={{ fontSize: 12, color: "#8a94a6" }}>{r?.user?.email}</div>
        </>
      );
      return r?.user?._id ? (
        <Link to={`/admin/user/profile/${r.user._id}`} style={{ textDecoration: "none", cursor: "pointer" }}>
          {content}
        </Link>
      ) : (
        <div>{content}</div>
      );
    },
  },
  {
    key: "email",
    title: "Email",
    defaultVisible: false,
    render: (r) => r?.user?.email || "-",
  },
  {
    key: "phoneNumber",
    title: "Phone Number",
    defaultVisible: false,
    render: (r) => r?.user?.phoneNumber || "-",
  },
  {
    key: "_id",
    title: "User _id",
    defaultVisible: false,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.user?._id || "-"}</span>,
  },
  {
    key: "userId",
    title: "User ID",
    defaultVisible: false,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.user?.userId?.toUpperCase() || "-"}</span>,
  },
  {
    key: "amount",
    title: "Amount",
    defaultVisible: true,
    align: "right",
    render: (r) =>
      r?.amount !== undefined && r?.amount !== null
        ? <span style={{ fontWeight: 600, color: "#1b5a90" }}>{r?.amount?.toFixed(2) || 0} {r?.coin?.symbol || ""}</span>
        : "-",
  },
  {
    key: "amountAfterDeduction",
    title: "Final Amount",
    defaultVisible: false,
    align: "right",
    render: (r) =>
      r?.amountAfterDeduction !== undefined && r?.amountAfterDeduction !== null
        ? <span style={{ fontWeight: 700, color: "#28a745" }}>{r?.amountAfterDeduction?.toFixed(2) || 0} {r?.coin?.symbol || ""}</span>
        : "-",
  },
  {
    key: "utrNumber",
    title: "UTR No.",
    defaultVisible: true,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.utrNumber || "-"}</span>,
  },
  {
    key: "bankAccountNumber",
    title: "Bank A/c No.",
    defaultVisible: true,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.userBankDetails?.bankAccountNumber || "-"}</span>,
  },
  {
    key: "bankIfsc",
    title: "IFSC Code",
    defaultVisible: true,
    render: (r) => <span style={{ fontFamily: "monospace", fontSize: 12, color: "#374151" }}>{r?.userBankDetails?.bankIfsc || "-"}</span>,
  },
  {
    key: "coin",
    title: "Coin",
    defaultVisible: false,
    render: (r) => r?.coin?.symbol
      ? <span style={{ background: "#eef4fb", color: "#1b5a90", borderRadius: 6, padding: "2px 8px", fontWeight: 600, fontSize: 12 }}>{r.coin.symbol}</span>
      : "-",
  },
  {
    key: "status",
    title: "Status",
    defaultVisible: true,
    render: (r) => renderStatus(r?.status),
  },
  {
    key: "createdAt",
    title: "Request Date",
    defaultVisible: true,
    render: (r) => <span style={{ fontSize: 12, color: "#6b7280" }}>{formatDateTime(r?.createdAt)}</span>,
  },
];

const Deposit = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [edit, setEdit] = useState("");
  const [active, setActive] = useState("Pending");
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setRejectReason("");
    setRejectReasonError("");
    setOtpSent(false);
    setOtp("");
    setOtpError("");
    setOtpSending(false);
    setOtpResending(false);
    // Reset edit-deposit state
    setEditAmount("");
    setEditUtr("");
    setEditProofFile(null);
    setEditRemarks("");
    setEditErrors({});
    // Reset action-required state
    setActionReqReason("");
    setActionReqRemarks("");
    setActionReqReasonError("");
    setActionReqLoading(false);
  };
  const [id, setId] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasonError, setRejectReasonError] = useState("");
  const [actionReqReason, setActionReqReason] = useState("");
  const [actionReqRemarks, setActionReqRemarks] = useState("");
  const [actionReqReasonError, setActionReqReasonError] = useState("");
  const [actionReqLoading, setActionReqLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpResending, setOtpResending] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  // ── Create Credit Note modal state ────────────────────────────────────────
  const [createOpen, setCreateOpen] = useState(false);
  const [createUserId, setCreateUserId] = useState(null);
  const [createAmount, setCreateAmount] = useState("");
  const [createUtr, setCreateUtr] = useState("");
  const [createProofFile, setCreateProofFile] = useState(null);
  const [createRemarks, setCreateRemarks] = useState("");
  const [createErrors, setCreateErrors] = useState({});
  const [createLoading, setCreateLoading] = useState(false);
  const [userOptions, setUserOptions] = useState([]);
  const [userSearchLoading, setUserSearchLoading] = useState(false);

  // ── Edit pending deposit modal state ──────────────────────────────────────
  const [editAmount, setEditAmount] = useState("");
  const [editUtr, setEditUtr] = useState("");
  const [editProofFile, setEditProofFile] = useState(null);
  const [editRemarks, setEditRemarks] = useState("");
  const [editErrors, setEditErrors] = useState({});
  const [editLoading, setEditLoading] = useState(false);

  const {
    pageSize,
    setPageSize,
    pageSizeOptions,
    visibleColumnKeys,
    toggleColumn,
    resetColumns,
    dynamicColumns,
  } = useTableSettings({
    storageKey: "deposit-list-v2",
    allColumns: ALL_COLUMNS,
  });

  const getList = () => {
    let body = {
      page: page,
      sizePerPage: pageSize,
      pagination: true,
      type: "DEPOSIT",
      status: TAB_STATUS[active] ?? "PENDING",
    };
    if (searchTerm) body.search = searchTerm;
    if (startDate)  body.startDate = startDate;
    if (endDate)    body.endDate = endDate;

    setLoading(true);
    getWithdrawalReq(body)
      .then((res) => {
        if (res?.status) setList(res?.data);
        setLoading(false);
      })
      .finally(() => setLoading(false));
  };

  const handleDownload = (format) => {
    const body = {
      pagination: false,
      type: "DEPOSIT",
      status: TAB_STATUS[active] ?? "PENDING",
    };
    if (searchTerm) body.search = searchTerm;
    if (startDate)  body.startDate = startDate;
    if (endDate)    body.endDate = endDate;
    setDownloadLoading(true);
    getWithdrawalReq(body)
      .then((res) => {
        const result = res?.data?.result ?? [];
        if (!result.length) { toast.warning("Nothing to download", { toastId: 'nothing-to-download' }); return; }
        const cols = ALL_COLUMNS.filter((c) => visibleColumnKeys.includes(c.key));
        triggerDownload(format, result, cols, "deposits");
      })
      .finally(() => setDownloadLoading(false));
  };

  const handleUserSearch = (q) => {
    if (!q?.trim()) { setUserOptions([]); return; }
    setUserSearchLoading(true);
    getUser({ search: q, page: 1, sizePerPage: 20, pagination: true })
      .then((res) => {
        const list = res?.data?.result ?? [];
        console.log("%c Line:271 🍫 list", "color:#4fff4B", list);
        setUserOptions(
          list.map((u) => ({
            value: u._id,
            label: `${u.firstName ?? ""} ${u.lastName ?? ""} (${u.email})`.trim(),
          }))
        );
      })
      .finally(() => setUserSearchLoading(false));
  };

  const resetCreateState = () => {
    setCreateUserId(null);
    setCreateAmount("");
    setCreateUtr("");
    setCreateProofFile(null);
    setCreateRemarks("");
    setCreateErrors({});
    setUserOptions([]);
  };

  const handleCreateDeposit = () => {
    const errors = {};
    if (!createUserId)        errors.user = "Customer is required";
    const amt = Number(createAmount);
    if (!createAmount || !Number.isFinite(amt) || amt <= 0) errors.amount = "Valid amount is required";
    if (!createUtr.trim())    errors.utr = "UTR number is required";
    else if (!UTR_PATTERN.test(createUtr.trim())) errors.utr = "UTR must be 6–22 alphanumeric characters";
    if (Object.keys(errors).length) { setCreateErrors(errors); return; }

    const formData = new FormData();
    formData.append("userId",    createUserId);
    formData.append("amount",    String(amt));
    formData.append("utrNumber", createUtr.trim().toUpperCase());
    if (createRemarks.trim())  formData.append("remarks",      createRemarks.trim());
    if (createProofFile)       formData.append("paymentProof", createProofFile);

    setCreateLoading(true);
    createAdminDepositApi(formData)
      .then((res) => {
        if (res?.status) {
          toast.success("Deposit request created", { toastId: 'deposit-create-success' });
          setCreateOpen(false);
          resetCreateState();
          getList();
        } else {
          toast.error(res?.message || "Failed to create deposit", { toastId: 'deposit-create-error' });
        }
      })
      .catch((e) => toast.error(e?.response?.data?.message || "Failed to create deposit", { toastId: 'deposit-create-error' }))
      .finally(() => setCreateLoading(false));
  };

  const handleEditDeposit = () => {
    const errors = {};
    const amt = Number(editAmount);
    if (!editAmount || !Number.isFinite(amt) || amt <= 0) errors.amount = "Valid amount is required";
    if (!editUtr.trim())  errors.utr = "UTR number is required";
    else if (!UTR_PATTERN.test(editUtr.trim())) errors.utr = "UTR must be 6–22 alphanumeric characters";
    if (Object.keys(errors).length) { setEditErrors(errors); return; }

    const formData = new FormData();
    formData.append("amount",    String(amt));
    formData.append("utrNumber", editUtr.trim().toUpperCase());
    formData.append("remarks",   editRemarks.trim());
    if (editProofFile) formData.append("paymentProof", editProofFile);

    setEditLoading(true);
    updateDepositDetailsApi(id?._id, formData)
      .then((res) => {
        if (res?.status) {
          toast.success("Deposit updated", { toastId: 'deposit-update-success' });
          handleCloseDelete();
          getList();
        } else {
          toast.error(res?.message || "Failed to update deposit", { toastId: 'deposit-update-error' });
        }
      })
      .catch((e) => toast.error(e?.response?.data?.message || "Failed to update deposit", { toastId: 'deposit-update-error' }))
      .finally(() => setEditLoading(false));
  };

  const resetOtpState = () => {
    setOtpSent(false);
    setOtp("");
    setOtpError("");
    setOtpSending(false);
    setOtpResending(false);
  };

  const otpAction = edit === "rejecting" ? "REJECT" : "ACCEPT";

  const handleSendOtp = () => {
    if (otpSending || !id?._id) return;
    if (edit === "rejecting" && !rejectReason.trim()) {
      setRejectReasonError("Reject reason is required");
      return;
    }
    setOtpSending(true);
    setOtpError("");
    sendDepositApprovalOtpApi(id?._id, otpAction)
      ?.then((res) => {
        if (res?.status) {
          setOtpSent(true);
          toast.success(res?.message || "OTP sent to your email", { toastId: 'deposit-send-otp-success' });
        } else {
          toast.error(res?.message || "Failed to send OTP", { toastId: 'deposit-send-otp-error' });
        }
      })
      ?.catch((e) => toast.error(e?.response?.data?.message || "Failed to send OTP", { toastId: 'deposit-send-otp-error' }))
      ?.finally(() => setOtpSending(false));
  };

  const handleResendOtp = () => {
    if (otpResending || !id?._id) return;
    setOtpResending(true);
    setOtp("");
    setOtpError("");
    resendDepositApprovalOtpApi(id?._id, otpAction)
      ?.then((res) => {
        if (res?.status) {
          toast.success(res?.message || "A fresh OTP has been sent", { toastId: 'deposit-resend-otp-success' });
        } else {
          toast.error(res?.message || "Failed to resend OTP", { toastId: 'deposit-resend-otp-error' });
        }
      })
      ?.catch((e) => toast.error(e?.response?.data?.message || "Failed to resend OTP", { toastId: 'deposit-resend-otp-error' }))
      ?.finally(() => setOtpResending(false));
  };

  const handleStatus = () => {
    const isRejecting = edit === "rejecting";
    if (isRejecting && !rejectReason.trim()) {
      setRejectReasonError("Reject reason is required");
      return;
    }
    if (!otpSent) { setOtpError("Please request an OTP first"); return; }
    if (!otp.trim()) { setOtpError("Please enter the OTP sent to your email"); return; }

    let body = { status: isRejecting ? "REJECT" : "ACCEPT", otp: otp.trim() };
    if (isRejecting) body.rejectReason = rejectReason.trim();

    setLoadingDelete(true);
    getWithdrawalStatus(id?._id, body)
      .then((res) => {
        if (res?.status) {
          getList();
          setId(false);
          resetOtpState();
          handleCloseDelete();
        } else {
          const msg = res?.message || "Action failed";
          if (/otp/i.test(msg)) setOtpError(msg);
          else toast.error(msg, { toastId: 'deposit-validation-error' });
        }
      })
      .catch((e) => {
        const msg = e?.response?.data?.message || "Action failed";
        if (/otp/i.test(msg)) setOtpError(msg);
        else toast.error(msg, { toastId: 'deposit-validation-error' });
      })
      .finally(() => setLoadingDelete(false));
  };

  const handleMarkActionRequired = () => {
    if (!actionReqReason.trim()) {
      setActionReqReasonError("Reason is required");
      return;
    }
    setActionReqLoading(true);
    markDepositActionRequiredApi(id?._id, {
      reason: actionReqReason.trim(),
      remarks: actionReqRemarks.trim() || undefined,
    })
      .then((res) => {
        if (res?.status) {
          toast.success(res?.message || "Deposit marked as Action Required", { toastId: 'deposit-action-required-success' });
          getList();
          setId(false);
          handleCloseDelete();
        } else {
          toast.error(res?.message || "Action failed", { toastId: 'deposit-action-required-error' });
        }
      })
      .catch((e) => toast.error(e?.response?.data?.message || "Action failed", { toastId: 'deposit-action-required-error' }))
      .finally(() => setActionReqLoading(false));
  };

  useEffect(() => { getList(); }, [page, pageSize, active, searchTerm, startDate, endDate]);
  useEffect(() => { setPage(1); }, [pageSize, active, searchTerm, startDate, endDate]);

  const handleDateRangeChange = (event, picker) => {
    setStartDate(picker.startDate.format("YYYY-MM-DD"));
    setEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  const actionColumn = {
    key: "__action",
    title: "Action",
    className: "text-end",
    render: (_, row) => {
      const viewBtn = (
        <a
          className="me-1 btn btn-sm bg-success-light"
          onClick={() => { setId(row); setEdit("View"); handleOpenDelete(); }}
        >
          View
        </a>
      );
      const rejectBtn = (
        <a
          onClick={() => { setEdit("rejecting"); setId(row); handleOpenDelete(); }}
          className="me-1 btn btn-sm bg-danger-light"
        >
          Reject
        </a>
      );

      if (active === "Pending") {
        const attemptsUsed = row?.actionRequiredCount ?? 0;
        const actionRequiredMaxedOut = attemptsUsed >= MAX_ACTION_REQUIRED_ATTEMPTS;
        return (
          <div className="text-end">
            {viewBtn}
            <a
              className="me-1 btn btn-sm"
              style={{ background: "#fff3cd", color: "#856404" }}
              onClick={() => {
                setId(row);
                setEdit("editing");
                setEditAmount(String(row.amount ?? ""));
                setEditUtr(row.utrNumber ?? "");
                setEditRemarks(row.remarks ?? "");
                setEditProofFile(null);
                setEditErrors({});
                handleOpenDelete();
              }}
            >
              Edit
            </a>
            <a
              className="me-1 btn btn-sm bg-success-light"
              onClick={() => { setId(row); setEdit("approving"); handleOpenDelete(); }}
            >
              Approve
            </a>
            {!actionRequiredMaxedOut && (
              <a
                className="me-1 btn btn-sm"
                style={{ background: "#ffe8cc", color: "#d16c00" }}
                title="Keep this request open and ask the user to re-upload proof"
                onClick={() => { setId(row); setEdit("actionRequired"); handleOpenDelete(); }}
              >
                Action Required
              </a>
            )}
            {rejectBtn}
          </div>
        );
      }

      if (active === "Action Required") {
        return (
          <div className="text-end">
            {viewBtn}
            {rejectBtn}
          </div>
        );
      }

      return <div className="text-end">{viewBtn}</div>;
    },
  };

  const columns2 = [...dynamicColumns, actionColumn];

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header py-3 mb-2">
            <div className="row align-items-center">
              <div className="col-sm-12">
                <h3 className="page-title mb-1">Deposit</h3>
                <ul className="breadcrumb mb-0" style={{ fontSize: 13 }}>
                  <li className="breadcrumb-item">
                    <Link to="/admin" className="text-decoration-none">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">Deposit</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between mb-3">
            <div style={{ display: "flex", gap: 4, background: "#f1f5f9", borderRadius: 12, padding: 5 }}>
              {tabs.map((obj) => (
                <button
                  key={obj}
                  onClick={() => setActive(obj)}
                  style={{ padding: "7px 16px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600, cursor: "pointer", background: active === obj ? "#1b5a90" : "transparent", color: active === obj ? "#fff" : "#6b7280" }}
                >
                  {obj}
                </button>
              ))}
            </div>
            <button
              className="btn btn-primary"
              onClick={() => setCreateOpen(true)}
            >
              + Create Credit Note
            </button>
          </div>

          <div className="list-layout">
            <div className="list-layout__main">
              <div className="card" style={{ borderRadius: 12, border: "1px solid #e9ecef", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                <div className="card-body">
                  <TableToolbar
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    pageSizeOptions={pageSizeOptions}
                    total={list?.total}
                    page={page}
                    visibleColumnKeys={visibleColumnKeys}
                    allColumns={ALL_COLUMNS}
                    toggleColumn={toggleColumn}
                    resetColumns={resetColumns}
                    onDownload={handleDownload}
                    downloadLoading={downloadLoading}
                    onRefresh={getList}
                    refreshLoading={loading}
                  />
                  <div className="table-responsive">
                    {loading ? (
                      <div className="his-spin">
                        <Spin size="large" style={{ position: "relative", top: "35%" }} />
                      </div>
                    ) : (
                      <Table
                        pagination={false}
                        style={{ overflowX: "auto" }}
                        columns={columns2}
                        dataSource={list ? list?.result : []}
                        rowKey={(record) => record._id || record.id}
                      />
                    )}
                    {list && list?.total > pageSize && (
                      <CustomPagination
                        key={`pg-${pageSize}`}
                        totalTabs={list?.total}
                        tabsPerPage={pageSize}
                        handleChange={setPage}
                        className={`${loading ? "display-hide" : "display-flex"}`}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="list-layout__filters">
              <FilterPanel
                count={list?.total}
                onClear={() => { setSearchTerm(""); setStartDate(); setEndDate(); }}
              >
                <FilterPanel.Field label="Search">
                  <input
                    type="text"
                    placeholder="User name or email"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(sanitizeInput(e.target.value))}
                  />
                </FilterPanel.Field>
                <FilterPanel.Field label="Date Range">
                  <DateRangePicker onApply={handleDateRangeChange} isClearable={true}>
                    <input type="text" placeholder="Select date range" readOnly />
                  </DateRangePicker>
                </FilterPanel.Field>
              </FilterPanel>
            </div>
          </div>

          {/* ── View / Approve / Reject / Edit modal ──────────────────────── */}
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={openDelete}
            onClose={handleCloseDelete}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
          >
            <Fade in={openDelete}>
              <Box style={styleDelete}>
                <div style={{ margin: "2px", textAlign: "center", fontWeight: 600, marginBottom: 8 }}>
                  {edit === "View"
                    ? "Deposit details"
                    : edit === "editing"
                    ? "Edit Deposit"
                    : edit === "actionRequired"
                    ? "Mark as Action Required"
                    : `Please confirm before ${edit}`}
                </div>

                {/* Common detail rows (View / approving / rejecting / actionRequired) */}
                {edit !== "editing" && (
                  <>
                    <div className="d-flex justify-content-center align-items-center mb-2">
                      <span className="fw-bold">{id?.user?.firstName} {id?.user?.lastName}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Amount</span>
                      <span className="fw-bold">{id?.amount} {id?.coin?.symbol}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>UTR No.</span>
                      <span className="fw-bold" style={{ wordBreak: "break-all", textAlign: "right" }}>
                        {id?.utrNumber || "-"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Date</span>
                      <span className="fw-bold">{moment(id?.createdAt).format("DD/MM/YYYY h:mm")}</span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Payment Proof</span>
                      <span
                        onClick={() => window.open(id?.paymentProof, "_blank")}
                        style={{ cursor: "pointer", color: "blue" }}
                        className="fw-bold"
                      >
                        Click here to see
                      </span>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span>Status</span>
                      <span className="fw-bold">{id?.status}</span>
                    </div>
                    {edit === "View" && id?.remarks && (
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span>Remarks</span>
                        <span className="fw-bold" style={{ wordBreak: "break-word", textAlign: "right", maxWidth: "60%" }}>
                          {id.remarks}
                        </span>
                      </div>
                    )}
                    {edit === "View" && id?.status === "REJECT" && id?.rejectReason && (
                      <div className="mb-2">
                        <div>Reject Reason</div>
                        <div className="fw-bold" style={{ wordBreak: "break-word" }}>{id.rejectReason}</div>
                      </div>
                    )}
                    {edit === "View" && id?.status === "REJECT" && (id?.rejectedByEmail || id?.rejectedBy) && (
                      <>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span>Rejected By</span>
                          <span className="fw-bold">{id?.rejectedByEmail || id?.rejectedBy}</span>
                        </div>
                        {id?.rejectedAt && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span>Rejected At</span>
                            <span className="fw-bold">{moment(id.rejectedAt).format("DD/MM/YYYY HH:mm")}</span>
                          </div>
                        )}
                      </>
                    )}
                    {edit === "View" && id?.status === "ACCEPT" && (id?.acceptedByEmail || id?.acceptedBy) && (
                      <>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span>Approved By</span>
                          <span className="fw-bold">{id?.acceptedByEmail || id?.acceptedBy}</span>
                        </div>
                        {id?.acceptedAt && (
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span>Approved At</span>
                            <span className="fw-bold">{moment(id.acceptedAt).format("DD/MM/YYYY HH:mm")}</span>
                          </div>
                        )}
                      </>
                    )}

                    {/* Action Required audit trail */}
                    {edit === "View" && id?.actionRequiredHistory?.length > 0 && (
                      <div className="mt-3" style={{ borderTop: "1px dashed #ddd", paddingTop: 10 }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-bold">Action Required — Audit Trail</span>
                          <span style={{ fontSize: 12, color: "#856404" }}>
                            {id?.actionRequiredCount ?? id.actionRequiredHistory.length} / {MAX_ACTION_REQUIRED_ATTEMPTS} used
                          </span>
                        </div>
                        {id.actionRequiredHistory.map((entry, idx) => (
                          <div
                            key={idx}
                            className="mb-2"
                            style={{ background: "#fffaf0", border: "1px solid #ffe8cc", borderRadius: 8, padding: 10, fontSize: 12 }}
                          >
                            <div className="d-flex justify-content-between mb-1">
                              <span style={{ color: "#856404", fontWeight: 600 }}>Attempt {idx + 1}</span>
                              <span style={{ color: "#6b7280" }}>{formatDateTime(entry.markedAt)}</span>
                            </div>
                            <div className="mb-1"><span style={{ color: "#6b7280" }}>By:</span> {entry.adminEmail || entry.adminId}</div>
                            <div className="mb-1"><span style={{ color: "#6b7280" }}>Reason:</span> {entry.reason}</div>
                            {entry.remarks && (
                              <div className="mb-1"><span style={{ color: "#6b7280" }}>Remarks:</span> {entry.remarks}</div>
                            )}
                            <div className="row mt-2" style={{ margin: 0 }}>
                              <div className="col-6" style={{ paddingLeft: 0 }}>
                                <div style={{ fontWeight: 600, color: "#374151" }}>Previous submission</div>
                                <div>Amount: {entry.previousSubmission?.amount ?? "-"}</div>
                                <div>UTR: {entry.previousSubmission?.utrNumber || "-"}</div>
                                {entry.previousSubmission?.paymentProof && (
                                  <div>
                                    <span
                                      style={{ color: "blue", cursor: "pointer" }}
                                      onClick={() => window.open(entry.previousSubmission.paymentProof, "_blank")}
                                    >
                                      View proof
                                    </span>
                                  </div>
                                )}
                              </div>
                              <div className="col-6" style={{ paddingRight: 0 }}>
                                <div style={{ fontWeight: 600, color: "#374151" }}>Resubmission</div>
                                {entry.resubmission ? (
                                  <>
                                    <div>Amount: {entry.resubmission.amount ?? "-"}</div>
                                    <div>UTR: {entry.resubmission.utrNumber || "-"}</div>
                                    {entry.resubmission.paymentProof && (
                                      <div>
                                        <span
                                          style={{ color: "blue", cursor: "pointer" }}
                                          onClick={() => window.open(entry.resubmission.paymentProof, "_blank")}
                                        >
                                          View proof
                                        </span>
                                      </div>
                                    )}
                                    <div style={{ color: "#6b7280" }}>
                                      Resubmitted: {formatDateTime(entry.resubmission.submittedAt)}
                                    </div>
                                  </>
                                ) : (
                                  <div style={{ color: "#9ca3af" }}>Awaiting user resubmission…</div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}

                {/* Reject reason input */}
                {edit === "rejecting" && (
                  <div className="mb-2">
                    <label className="mb-1">Reject Reason <span style={{ color: "red" }}>*</span></label>
                    <textarea
                      className="form-control"
                      rows={3}
                      maxLength={500}
                      placeholder="Enter reason for rejection"
                      value={rejectReason}
                      onChange={(e) => { setRejectReason(e.target.value); if (rejectReasonError) setRejectReasonError(""); }}
                    />
                    {rejectReasonError && <div style={{ color: "red", fontSize: "12px" }}>{rejectReasonError}</div>}
                  </div>
                )}

                {/* Action Required — reason (free text, no fixed list — there's no
                    single enum of reasons that covers every unusable-proof case)
                    + optional remarks */}
                {edit === "actionRequired" && (
                  <div className="mb-2">
                    <label className="mb-1">Reason <span style={{ color: "red" }}>*</span></label>
                    <textarea
                      className="form-control"
                      rows={3}
                      maxLength={500}
                      placeholder="e.g. Screenshot is blurry and the transaction details aren't readable"
                      value={actionReqReason}
                      onChange={(e) => { setActionReqReason(e.target.value); if (actionReqReasonError) setActionReqReasonError(""); }}
                    />
                    {actionReqReasonError && <div style={{ color: "red", fontSize: "12px" }}>{actionReqReasonError}</div>}
                    <label className="mb-1 mt-2">
                      Remarks <span style={{ color: "#888", fontSize: 11 }}>(optional)</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows={2}
                      maxLength={500}
                      placeholder="Internal note"
                      value={actionReqRemarks}
                      onChange={(e) => setActionReqRemarks(e.target.value)}
                    />
                    <div style={{ fontSize: 12, color: "#666", marginTop: 6 }}>
                      The user will be notified with this reason and can re-upload payment proof for the same request. Attempt {(id?.actionRequiredCount ?? 0) + 1} of {MAX_ACTION_REQUIRED_ATTEMPTS}.
                    </div>
                  </div>
                )}

                {/* OTP input for deposit approve / reject */}
                {(edit === "approving" || edit === "rejecting") && (
                  <div className="mb-2 mt-2">
                    {!otpSent ? (
                      <div style={{ fontSize: 12, color: "#666", textAlign: "center" }}>
                        For security, an OTP will be sent to your admin email before {edit === "approving" ? "approving" : "rejecting"} this deposit.
                      </div>
                    ) : (
                      <>
                        <label className="mb-1">Enter OTP <span style={{ color: "red" }}>*</span></label>
                        <input
                          type="text"
                          className="form-control"
                          maxLength={6}
                          autoFocus
                          inputMode="numeric"
                          pattern="\d*"
                          placeholder="6-digit code from email"
                          value={otp}
                          onChange={(e) => {
                            const v = e.target.value.replace(/\D/g, "").slice(0, 6);
                            setOtp(v);
                            if (otpError) setOtpError("");
                          }}
                        />
                        {otpError && <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>{otpError}</div>}
                        <div style={{ textAlign: "right", marginTop: 6 }}>
                          <button
                            type="button"
                            onClick={handleResendOtp}
                            disabled={otpResending}
                            className="btn btn-link btn-sm p-0"
                            style={{ fontSize: 12 }}
                          >
                            {otpResending ? "Sending…" : "Resend OTP"}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                )}

                {/* Edit deposit fields */}
                {edit === "editing" && (
                  <div>
                    <div className="mb-2">
                      <label className="mb-1">Amount <span style={{ color: "red" }}>*</span></label>
                      <input
                        type="number"
                        min="0.01"
                        className="form-control"
                        placeholder="Enter amount"
                        value={editAmount}
                        onChange={(e) => { setEditAmount(e.target.value); if (editErrors.amount) setEditErrors((p) => ({ ...p, amount: "" })); }}
                      />
                      {editErrors.amount && <div style={{ color: "red", fontSize: 12 }}>{editErrors.amount}</div>}
                    </div>
                    <div className="mb-2">
                      <label className="mb-1">UTR No. <span style={{ color: "red" }}>*</span></label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={22}
                        placeholder="6–22 alphanumeric"
                        value={editUtr}
                        onChange={(e) => { setEditUtr(e.target.value); if (editErrors.utr) setEditErrors((p) => ({ ...p, utr: "" })); }}
                      />
                      {editErrors.utr && <div style={{ color: "red", fontSize: 12 }}>{editErrors.utr}</div>}
                    </div>
                    <div className="mb-2">
                      <label className="mb-1">
                        Payment Proof <span style={{ color: "#888", fontSize: 11 }}>(optional)</span>
                      </label>
                      {id?.paymentProof && !editProofFile && (
                        <div style={{ fontSize: 12, marginBottom: 4 }}>
                          Current:{" "}
                          <span
                            style={{ color: "blue", cursor: "pointer" }}
                            onClick={() => window.open(id.paymentProof, "_blank")}
                          >
                            View existing proof
                          </span>
                        </div>
                      )}
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*,application/pdf"
                        onChange={(e) => setEditProofFile(e.target.files?.[0] ?? null)}
                      />
                    </div>
                    <div className="mb-2">
                      <label className="mb-1">
                        Remarks <span style={{ color: "#888", fontSize: 11 }}>(optional)</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={2}
                        maxLength={500}
                        placeholder="Internal note"
                        value={editRemarks}
                        onChange={(e) => setEditRemarks(e.target.value)}
                      />
                    </div>
                  </div>
                )}

                {/* Action buttons */}
                {edit === "editing" ? (
                  <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 12 }}>
                    <button className="btn btn-primary" onClick={handleEditDeposit} disabled={editLoading}>
                      {editLoading ? <Spinner size="sm" /> : "Save"}
                    </button>
                    <button className="btn btn-secondary" onClick={handleCloseDelete}>Cancel</button>
                  </div>
                ) : edit === "actionRequired" ? (
                  <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 12 }}>
                    <button
                      className="btn"
                      style={{ background: "#d16c00", color: "#fff" }}
                      onClick={handleMarkActionRequired}
                      disabled={actionReqLoading}
                    >
                      {actionReqLoading ? <Spinner size="sm" /> : "Mark Action Required"}
                    </button>
                    <button className="btn btn-secondary" onClick={handleCloseDelete}>Cancel</button>
                  </div>
                ) : (active === "Pending" || active === "Action Required") ? (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {edit !== "View" &&
                      ((edit === "approving" || edit === "rejecting") && !otpSent ? (
                        <button
                          onClick={handleSendOtp}
                          className={`btn ${edit === "approving" ? "btn-success" : "btn-danger"}`}
                          disabled={otpSending}
                          style={{ marginBottom: "10px", marginTop: "15px" }}
                        >
                          {otpSending ? <Spinner size="sm" /> : "Send OTP"}
                        </button>
                      ) : (
                        <button
                          onClick={handleStatus}
                          className={`btn ${edit === "approving" ? "btn-success" : "btn-danger"}`}
                          disabled={loadingDelete || otp.length !== 6}
                          style={{ marginBottom: "10px", marginTop: "15px" }}
                        >
                          {loadingDelete ? <Spinner size="sm" /> : edit === "approving" ? "Approve" : "Reject"}
                        </button>
                      ))}
                    <button
                      className="btn btn-primary"
                      onClick={handleCloseDelete}
                      style={{ marginLeft: "7px", marginBottom: "10px", marginTop: "15px" }}
                    >
                      Cancel
                    </button>
                  </div>
                ) : null}
              </Box>
            </Fade>
          </Modal>

          {/* ── Create Credit Note modal ───────────────────────────────────── */}
          <Modal
            open={createOpen}
            onClose={() => { setCreateOpen(false); resetCreateState(); }}
            closeAfterTransition
            slots={{ backdrop: backdrop }}
            slotProps={{ backdrop: { timeout: 500 } }}
          >
            <Fade in={createOpen}>
              <Box style={styleDelete}>
                <div style={{ textAlign: "center", fontWeight: 600, marginBottom: 12 }}>
                  Create Credit Note
                </div>

                <div className="mb-2">
                  <label className="mb-1">Customer <span style={{ color: "red" }}>*</span></label>
                  <Select
                    showSearch
                    filterOption={false}
                    style={{ width: "100%" }}
                    placeholder="Search by name or email"
                    loading={userSearchLoading}
                    onSearch={handleUserSearch}
                    options={userOptions}
                    value={createUserId || undefined}
                    getPopupContainer={() => document.body}
                    dropdownStyle={{ zIndex: 1500 }}
                    onChange={(val) => {
                      setCreateUserId(val);
                      if (createErrors.user) setCreateErrors((p) => ({ ...p, user: "" }));
                    }}
                    notFoundContent={userSearchLoading ? "Searching…" : "Type to search"}
                  />
                  {createErrors.user && <div style={{ color: "red", fontSize: 12 }}>{createErrors.user}</div>}
                </div>

                <div className="mb-2">
                  <label className="mb-1">Amount <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="number"
                    min="0.01"
                    className="form-control"
                    placeholder="Enter amount"
                    value={createAmount}
                    onChange={(e) => { setCreateAmount(e.target.value); if (createErrors.amount) setCreateErrors((p) => ({ ...p, amount: "" })); }}
                  />
                  {createErrors.amount && <div style={{ color: "red", fontSize: 12 }}>{createErrors.amount}</div>}
                </div>

                <div className="mb-2">
                  <label className="mb-1">UTR No. <span style={{ color: "red" }}>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    maxLength={22}
                    placeholder="6–22 alphanumeric"
                    value={createUtr}
                    onChange={(e) => { setCreateUtr(e.target.value); if (createErrors.utr) setCreateErrors((p) => ({ ...p, utr: "" })); }}
                  />
                  {createErrors.utr && <div style={{ color: "red", fontSize: 12 }}>{createErrors.utr}</div>}
                </div>

                <div className="mb-2">
                  <label className="mb-1">
                    Payment Proof <span style={{ color: "#888", fontSize: 11 }}>(optional)</span>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*,application/pdf"
                    onChange={(e) => setCreateProofFile(e.target.files?.[0] ?? null)}
                  />
                </div>

                <div className="mb-2">
                  <label className="mb-1">
                    Remarks <span style={{ color: "#888", fontSize: 11 }}>(optional)</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows={2}
                    maxLength={500}
                    placeholder="Internal note"
                    value={createRemarks}
                    onChange={(e) => setCreateRemarks(e.target.value)}
                  />
                </div>

                <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 12 }}>
                  <button className="btn btn-success" onClick={handleCreateDeposit} disabled={createLoading}>
                    {createLoading ? <Spinner size="sm" /> : "Submit"}
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => { setCreateOpen(false); resetCreateState(); }}
                  >
                    Cancel
                  </button>
                </div>
              </Box>
            </Fade>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Deposit;
